import { useDispatch, useSelector } from 'react-redux'
import { useEffectOnce } from '@chilecompra/react-kit'
import { Spinner } from '@chilecompra/react-kit/components'
import PropTypes from 'prop-types'

import { NotFoundPage } from '../../pages'
import { onGetTokenThunk } from './AuthProvider.actions'
import { AuthProviderContext } from './AuthProvider.context'
import { Root } from './AuthProvider.styles'

/**
 * The AuthProvider container.
 */
const AuthProvider = ({ children }) => {
  const dispatch = useDispatch()

  const { accessToken, error, isTokenLoading, loading, userType } = useSelector(
    state => state.authProvider
  )

  useEffectOnce(() => {
    if (accessToken) return

    dispatch(onGetTokenThunk())
  })

  const isAuthenticated = !loading && !isTokenLoading

  if (!isAuthenticated) {
    return (
      <Root size={12}>
        <Spinner />
      </Root>
    )
  }

  if (!accessToken || !userType || error) {
    return <NotFoundPage />
  }

  return (
    <AuthProviderContext.Provider value={{ userType }}>{children}</AuthProviderContext.Provider>
  )
}

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired
}

export default AuthProvider
